import { Component  } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';

import { OpcionModel } from '../Global/Opcion.model';
import * as TerceroModel from './Tercero.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { ConfirmarEliminacionService } from '../Dialog/ConfirmarEliminacionService';

@Component({
	selector : 'TerceroIndex',
	templateUrl : './TerceroIndex.component.html',
	styleUrls  : ['../../../../styles.css']

})


export class TerceroIndexComponent  {
	
	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	public btnConsultar:boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public bloquearBtn:boolean;

	public cnumcont:string;
	public patrimonios:Array<OpcionModel>;
	public patrimonio:OpcionModel;
	public terceros:Array<TerceroModel.TerceroModel>;
	public displayedColumns;
	public dataSource;
	
	public ocultar: boolean = false;
	public mensaje: string = "";

	myControl = new FormControl();
	filteredOptions: Observable<OpcionModel[]>;
	options = [];

	public validarFactura:boolean = (ServiciosGenerales.temporalCrearFacturaComponent != null);

	constructor(private _serviciosGenerales:ServiciosGenerales,
		public snackBar: MatSnackBar,
		private _router:Router,
		private _route: ActivatedRoute, 
		private confirmarEliminacionService:ConfirmarEliminacionService){

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
		
		this.patrimonios = new Array();
		this.terceros = new Array();
		this.patrimonio = new OpcionModel('',"");

		this.bloquearBtn = false;

	}


	ngOnInit(){
		console.log('Inicia...');
		
		this.displayedColumns = ['identificacion', 'nombre', 'primerApellido', 'segundoApellido', 'Habilitado', 'opciones'];
		this.dataSource = new ExampleDataSource(null);	
		this.iniciarLista();
		
	}


	filter(val: string)//: string[]
	{
		if(val == null){
			val = "";
		}
		let x = this.patrimonios.filter(option =>(option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1); 
		
		return x;
	}

	eventoConsulta(){
		this.patrimonio.idOpcion = this.patrimonio.labelOpcion.substring(0,this.patrimonio.labelOpcion.indexOf('-'));
		console.log(this.patrimonio);
		this.consultarTerceros();
	}


	iniciarLista(){
		
		this._serviciosGenerales.get('listaPatrimonios', {param:0}).subscribe(result =>{
			for(let x of result){
				this.patrimonios.push(new OpcionModel(x.cnumcont, x.vnombrenegocio));
			};
			
			this._route.params.subscribe( params =>{
				this.patrimonio.idOpcion = params['cnumcont'];
				
				if(!!params['cnumcont']){
					for(let x in this.patrimonios){
						if(this.patrimonios[x].idOpcion.indexOf(params['cnumcont'].trim()) > -1){
							this.patrimonio.labelOpcion = this.patrimonios[x].idOpcion.trim()+' - '+this.patrimonios[x].labelOpcion.trim();
							break;
						}
					}

					this.consultarTerceros();
				}

				this.filteredOptions = this.myControl.valueChanges
				.startWith(null)
				.map(val => val ? this.filter(val) : this.patrimonios.slice());

			})

		}, 
		error =>{
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
			this.openSnackBarEspecial("Ocurrió un error al momento de cargar los patrimonios", "X");

		});
	}




	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}


	
	


	consultarTerceros(){
		
		this.dataSource = new ExampleDataSource(null);	
		this.terceros = new Array();
		
		this._serviciosGenerales.get('tercerosAsociados', {cnumcont:this.patrimonio.idOpcion}).subscribe(result =>{
			
			for(let x of result){
				this.terceros.push(new TerceroModel.TerceroModel(
					new TerceroModel.DefTiposdocumentos(x.ctipid),
					new TerceroModel.MchTercerosId(x.cnumid,x.cnumcont,x.ctipid, x.ntipoempresa),0,
					x.vnombre,x.vapellido, x.vapellido2,x.nestado,0,
					new TerceroModel.DefTipospersona(""),
					/*new TerceroModel.ParamNegocios(new TerceroModel.ParamNegociosId("", 0)),*/
					new TerceroModel.DefContribuyentes(""), '', '')) ;
			};
			this.dataSource = new ExampleDataSource(this.terceros);
			
		}, 

		error =>{
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
			this.openSnackBarEspecial("Ocurrió un error al momento de cargar los terceros asociados", "X");

		});

		console.log(this.terceros);
	}

	editarRegistro(registro){
		this._router.navigate(['/Tercero',registro.id.cnumcont,registro.id.ctipid,registro.id.cnumid]);
	}

	mostrarSucursal(registro){
		this._router.navigate(['/Sucursal',registro.id.cnumcont,
			registro.id.ctipid,
			registro.id.cnumid,
			registro.vnombre+' '+registro.vapellido+' '+registro.vapellido2,
			'index']);
	}

	agregar(){
		console.log(this.patrimonio);
		if(this.patrimonio.idOpcion == null || this.patrimonio.idOpcion.trim() == '' || this.patrimonio.idOpcion == undefined){
			this.openSnackBarEspecial("Debe seleccionar un negocio para poder añadir un tercero.", "X");
		}else {

			let x = this.patrimonios.filter(option => option.idOpcion.toLowerCase().split(' ').join('') === this.patrimonio.idOpcion.toLowerCase().split(' ').join('') ); 
			console.log(x);

			if(x.length == 0){
				this.openSnackBarEspecial("El contrato: "+this.patrimonio.idOpcion.trim()+" no existe", "X");
			}else{
				this._router.navigate(['/TerceroNew',this.patrimonio.idOpcion,' ',' ']);	
			}

		}
	}


	borrarRegistro(registro){
		console.log(registro);
		this.confirmarEliminacionService.abrirDialog({cnumcont:registro.id.cnumcont,ctipid:registro.id.ctipid,cnumid:registro.id.cnumid}, 'eliminarTercero/eliminarTercero');
		this.confirmarEliminacionService.eventoFin$.subscribe(r=>{
			this.consultarTerceros();
		})
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

}




export class ExampleDataSource {

	public data: Array<TerceroModel.TerceroModel>;
	

	constructor(tercero:Array<TerceroModel.TerceroModel>){
		this.data = new Array();
		
		
		if(tercero != null){
			for(let i of tercero){
				this.data.push(i);
			}
		}
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<TerceroModel.TerceroModel[]>
	{
		return Observable.of(this.data);
	}

	disconnect()
	{
	}
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Tercero/TerceroIndex.component.ts